<template>
  <div>
    <c-summary-navbar :userName="eipUserName" :protalName="protalName" @userLogout="logout()" />
    <div class="summaryNavbar">
      <div class="row">
        <div class="m-0 p-0 col-4">
          <span
            class="approverButton pl-5"
            style="padding-left:50px;"
          >REQUEST NUMBER : {{answerNumber}}</span>
        </div>
        <div class="col-4"></div>
        <div class="m-0 p-0 col-4 text-right">
          <button
            class="approverstatus"
            v-if="feedbackWorkFlow || gstWorkflow || quicklinkWorkflow"
            @click="openTrackingStatus(answerNumber)"
          >Approval Status</button>
          <b-modal
            v-model="openTrackingModal"
            ok-title="ok"
            title="TrackingStatus"
            @ok="closeTrackingModal($event)"
            @cancel="eventCancel($event)"
            scrollable
            :no-close-on-esc="true"
            :ok-only="true"
            size="xl"
          >
            <table class="table-striped wf-history-table">
              <tbody>
                <tr v-for="(i,index) in traceData" :key="index">
                  <td v-if="index==0 && originalArray.length > 0" class="trace-wrap">
                    <div
                      :title="originalArray[0].remarks.split('-senderdelimiter-')[1].split('~~~')[1].split('^^^')[0]"
                    >
                      <span class="bold">By:</span>
                      {{originalArray[0].remarks.split('-senderdelimiter-')[1].split('~~~')[1].split('^^^')[0]}}
                    </div>

                    <div :title="Partner">
                      <span class="bold">Role:</span> Partner
                    </div>
                    <div>
                      <span class="bold">Action:</span>
                      <span class="text-green">Submitted</span>
                    </div>
                    <div :title="originalArray[0].remarks.split('-receiverdelimiter-')[0]">
                      <span class="bold">Remarks:</span>
                      {{originalArray[0].remarks.split('-receiverdelimiter-')[0]}}
                    </div>
                    <!--div>{{j.insertedOn.replace('T',' ').split('.')[0]}}</div-->

                    <div :title="formatDateTime(originalArray[0].updatedOn,'T')">
                      <span class="bold">updated:</span>
                      {{formatDateTime(originalArray[0].updatedOn,'T')}}
                    </div>
                    <!--td>{{i.versionNumber}}</td>
    <td>{{i.companyCode}}</td>
                    <td>{{i.documentWorkflowId}}</td-->
                  </td>
                  <td
                    v-for="(j,k) in i"
                    :key="k"
                    class="trace-wrap"
                    v-if="j.isShow || j.actionStatus != 4 || ((j.frCode==0 || j.frCode ==101) && j.actionStatus==4)"
                  >
                    <div
                      v-if="!(index==0 && k==0)"
                      :title="j.remarks.split('-receiverdelimiter-')[1].split('-senderdelimiter-')[0].split('~~~')[1].split('^^^')[0]"
                    >
                      <span class="bold">Actor:</span>
                      {{j.remarks.split('-receiverdelimiter-')[1].split('-senderdelimiter-')[0].split('~~~')[1].split('^^^')[0]}}
                    </div>
                    <div
                      v-if="index==0 && k==0"
                      :title="j.remarks.split('-senderdelimiter-')[1].split('~~~')[1].split('^^^')[0]"
                    >
                      <span class="bold">Actor:</span>
                      {{j.remarks.split('-senderdelimiter-')[1].split('~~~')[1].split('^^^')[0]}}
                    </div>
                    <div :title="getRoleName(j.frCode)">
                      <span class="bold">Role:</span>
                      {{getRoleName(j.frCode)}}
                    </div>
                    <div>
                      <span class="bold">Action:</span>
                      <span
                        v-if="(j.frCode ==0 || getRoleName(j.frCode) == 'Partner')"
                        class="text-green"
                      >Submitted</span>
                      <span
                        v-if="!(j.frCode ==0 || getRoleName(j.frCode) == 'Partner')"
                        :class="[j.actionStatus == 1 ? 'text-green':'', j.actionStatus == 2 ? 'text-orange':'',
    j.actionStatus == 3 ? 'text-red':'',j.actionStatus == 4 ? 'text-yellow':'']"
                      >
                        {{j.actionStatus == 1 ? 'Approved' : ''}}
                        {{j.actionStatus == 2 ? 'SendBack' : ''}}
                        {{j.actionStatus == 3 ? 'Rejected' : ''}}
                        {{j.actionStatus == 4 ? 'Requested' : ''}}
                        {{j.actionStatus == 5 ? 'PartialApproved' : ''}}
                        {{j.actionStatus == 6 ? 'AutoCancel' : ''}}
                        {{j.actionStatus == 7 ? 'Created' : ''}}
                        {{i.actionStatus == 8 ? 'Resolved' : ''}}
                        {{i.actionStatus == 9 ? 'Closed' : ''}}
                        {{i.actionStatus == 10 ? 'Forwarded' : ''}}
                        {{i.actionStatus == 11 ? 'Reopened' : ''}}
                        {{i.actionStatus == 13 ? 'Reviewed' : ''}}
                      </span>
                    </div>
                    <div :title="j.remarks.split('-receiverdelimiter-')[0]">
                      <span class="bold">Remarks:</span>
                      {{j.remarks.split('-receiverdelimiter-')[0]}}
                    </div>
                    <!--div>{{j.insertedOn.replace('T',' ').split('.')[0]}}</div-->
                    <div :title="formatDateTime(j.updatedOn,'T')">
                      <span class="bold">updated On:</span>
                      {{formatDateTime(j.updatedOn,'T')}}
                    </div>
                    <!--td>{{i.versionNumber}}</td>
    <td>{{i.companyCode}}</td>
                    <td>{{i.documentWorkflowId}}</td-->
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- <span > -->
            <div class="row m-0 p-3" v-for="(data,index) in trackingData" :key="index">
              <div class="col-2 m-0 p-0 pl-3">
                <h4
                  v-if="index == 0"
                  id="tooltip-target-1"
                  class="role-Name mb-2 m-0 p-0"
                >{{roleName[0]}}</h4>
                <!-- <b-tooltip target="tooltip-target-1" triggers="hover">I am tooltip</b-tooltip> -->
                <span v-if="data.partner != null">
                  <span :class="dottedStatus(data.partner.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.partner.evaluatorsActionStatus}}</span>
                  <br />
                  <span class="popOverDate">{{getCreatedDate(data.partner.insertedOn)}}</span>
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <!-- <span v-if="trackingData.length-1 == index">pending</span>
                  <span v-else>-</span>-->
                  <span>-</span>
                </span>
              </div>
              <div class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[1]}}</h4>
                <span v-if="data.segregator != null">
                  <span :class="dottedStatus(data.segregator.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.segregator.evaluatorsActionStatus}}</span>
                  <br />
                  <span class="popOverStatusActionBy">{{data.segregator.actionBy}}</span>
                  <br />
                  <span class="popOverDate">{{getCreatedDate(data.segregator.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.segregator.remarks"
                  >Remarks</button>
                  <!-- <b-popover
                    :target="`remarkssegPopover${index}`"
                    :show.sync="pop1"
                    placement="bottomright"
                    ref="remarkssegPopover"
                    triggers="hover"
                  >
                    <div>
                      <p class="p-2">{{data.segregator.remarks}}</p>
                    </div>
                  </b-popover>-->
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <!-- <span v-if="trackingData.length-1 == index">pending</span> -->
                  <span>-</span>
                </span>
              </div>
              <div class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[2]}}</h4>
                <span v-if="data.buyer != null">
                  <span :class="dottedStatus(data.buyer.evaluatorsActionStatus)"></span>

                  <span class="popOverStatus ml-2">{{data.buyer.evaluatorsActionStatus}}</span>
                  <br />
                  <span class="popOverStatusActionBy">{{data.buyer.actionBy}}</span>
                  <br />
                  <span class="popOverDate">{{getCreatedDate(data.buyer.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.buyer.remarks"
                  >Remarks</button>
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <span v-if="trackingData.length-1 == index">
                    <span :class="dottedStatus('Pending')"></span>
                    <span class="ml-2">Pending</span>
                  </span>
                  <span v-else>-</span>
                </span>
              </div>
              <div class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[3]}}</h4>
                <span v-if="data.technical != null">
                  <span :class="dottedStatus(data.technical.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.technical.evaluatorsActionStatus}}</span>
                  <br />
                  <span class="popOverStatusActionBy">{{data.technical.actionBy}}</span>
                  <br />
                  <span class="popOverDate">{{getCreatedDate(data.technical.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.technical.remarks"
                  >Remarks</button>
                  <!-- <b-popover
                    :target="`remarksTechPopover${index}`"
                    :show.sync="pop1"
                    placement="bottom"
                    ref="remarksTechPopover"
                    triggers="hover"
                  >
                    <div>
                      <p class="p-2">{{data.technical.remarks}}></p>
                    </div>
                  </b-popover>-->
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <span v-if="trackingData.length-1 == index">
                    <span :class="dottedStatus('Pending')"></span>
                    <span class="ml-2">Pending</span>
                  </span>
                  <span v-else>-</span>
                </span>
              </div>
              <div v-if="roleName.length != 4" class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[4]}}</h4>
                <span v-if="data.commercial != null">
                  <span :class="dottedStatus(data.commercial.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.commercial.evaluatorsActionStatus}}</span>
                  <br />
                  <span class="popOverStatusActionBy">{{data.commercial.actionBy}}</span>
                  <br />
                  <span class="popOverDate">{{getCreatedDate(data.commercial.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.commercial.remarks"
                  >Remarks</button>
                  <!-- <b-popover
                    :target="`remarksCommPopover${index}`"
                    :show.sync="pop1"
                    placement="bottom"
                    ref="remarksCommPopover"
                    triggers="hover"
                  >
                    <div>
                      <p class="p-2">{{data.commercial.remarks}}></p>
                    </div>
                  </b-popover>-->
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <span v-if="trackingData.length-1 == index">
                    <span :class="dottedStatus('Pending')"></span>
                    <span class="ml-2">Pending</span>
                  </span>
                  <span v-else>-</span>
                </span>
              </div>
              <div v-if="roleName.length != 4" class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[5]}}</h4>
                <span v-if="data.approver != null">
                  <span :class="dottedStatus(data.approver.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.approver.evaluatorsActionStatus}}</span>
                  <br />
                  <span class="popOverStatusActionBy">{{data.approver.actionBy}}</span>
                  <br />
                  <span class="popOverDate">{{getCreatedDate(data.approver.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.approver.remarks"
                  >Remarks</button>
                  <!-- <b-popover
                    :target="`remarksAppPopover${index}`"
                    :show.sync="pop1"
                    ref="remarksAppPopover"
                    triggers="hover"
                  >
                    <div>
                      <p class="p-2">{{data.approver.remarks}}></p>
                    </div>
                  </b-popover>-->
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <span v-if="trackingData.length-1 == index">
                    <p :class="dottedStatus('Pending')"></p>
                    <span class="ml-2">Pending</span>
                  </span>
                  <span v-else>-</span>
                </span>
              </div>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
    <div class="m-5">
      <div class="row" style="text-align: left;background: #fff;border-radius: 10px;padding: 5px;">
        <div class="col-12" style="font-weight:bold;font-size:18px;">Partner Details</div>
        <div class="col-12 col-sm-6 col-xs-6" style="font-weight:bold;">
          Partner Name:
          <span style="font-weight:normal;">{{partnerHeader.companyName}}</span>
          <span
            v-if="moduleWorkflow !='COB'"
            style="color:blue;text-decoration:underline;cursor:pointer;"
            @click="goToVendorMasterPage()"
          >View Profile</span>
        </div>
        <div class="col-12 col-sm-6 col-xs-6" style="font-weight:bold;">
          Partner Number:
          <span style="font-weight:normal;">{{partnerHeader.partnerNumber}}</span>
        </div>
        <div class="col-12 col-sm-6 col-xs-6" style="font-weight:bold;">
          Country:
          <span style="font-weight:normal;">{{partnerHeader.country}}</span>
        </div>
        <div class="col-12 col-sm-6 col-xs-6" style="font-weight:bold;">
          Partner Category:
          <span style="font-weight:normal;">{{partnerHeader.partnerCategory}}</span>
        </div>
        <div class="col-12 col-sm-6 col-xs-6" style="font-weight:bold;">
          Partner Classification:
          <span
            style="font-weight:normal;"
          >{{partnerHeader.classificationType}}</span>
        </div>
        <div class="col-12 col-sm-6 col-xs-6" style="font-weight:bold;">
          {{partnerHeader.uniqueIdCardType}}:
          <span
            style="font-weight:normal;"
          >{{partnerHeader.idCardValue}}</span>
        </div>
      </div>

      <c-evaluation
        v-if="pcrworkflow"
        :poNumber="orderNumber"
        :vendorCode="vendorCode"
        :jobCode="jobCode"
        :companyCode="companyCode"
        :jobType="ordertype"
        :FeedbackStatus="currentTab"
        :documentNumber="documentNumberValue"
        :claimObj="claimObj"
        :viewAs="'approver'"
        :claimDetails="claimDetails"
        :answernumber="answerNumber"
        @navigateBack="successReponse($event)"
      />

      <c-gst v-if="gstWorkflow" :answerNumber="answerNumber" />
      <c-quicklink
        v-if="quicklinkWorkflow"
        :answerNumber="answerNumber"
        :country="partnerHeader.country"
      />

      <c-cob v-if="customerWorkflow" :answerNumber="answerNumber" :country="partnerHeader.country" />
      <c-kyc
        v-if="kycWorkflow"
        :answerNumber="answerNumber"
        :country="partnerHeader.country"
        :partnerId="partnerHeader.partnerTypeList[0].id.partnerId"
        :companyCode="partnerHeader.partnerTypeList[0].id.companyCode"
      />
      <c-testimonials
        v-if="testimonialsWorkflow"
        :answerNumber="answerNumber"
        @testimonialDuration="getTestimonialDuration($event)"
      />
      <c-business-category v-if="businessCatWorkflow" :answerNumber="answerNumber" />
      <c-feedback
        v-if="feedbackWorkFlow"
        :documentNumber="answerNumber"
        :FeedbackStatus="'workflow'"
        @getuserValue="getUserInputValue($event)"
      />

      <div v-if="moduleWorkflow=='PSD'">
        <div style="font-weight: bold;text-align: left;margin-top:10px;">Existing Statutory Details</div>
        <div class="pb-3">
          <div
            class="table-wrapper-scroll-y my-custom-scrollbar table-responsive"
            style="opacity:0.6;cursor:none;"
          >
            <table class="table table-striped mb-0">
              <thead>
                <tr>
                  <th scope="col" v-if="partnerHeader.country=='India'">TAN Number</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">TAN Dcoument</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">Is MSME</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">MSME Number</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">MSME Document</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">MSME Type</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">MSME Effective From</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">MSME Classification Year</th>

                  <th scope="col" v-if="partnerHeader.country!='India'">VAT Number</th>
                  <th scope="col" v-if="partnerHeader.country!='India'">VAT Document</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">Aadhaar Number</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">Aadhaar Document</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-if="statutoryDetails">
                  <td
                    scope="col"
                    v-if="partnerHeader.country=='India'"
                  >{{statutoryDetails.tanNumber}}</td>

                  <td scope="col" v-if="partnerHeader.country=='India'">
                    <a
                      v-if="statutoryDetails.tanDocumentId!=null"
                      @click="showAttachFile(statutoryDetails.tanDocumentId)"
                      href="#"
                    >{{getFileName(statutoryDetails.tanDocumentId)}}</a>
                    <span v-else>{{getFileName(statutoryDetails.tanDocumentId)}}</span>
                  </td>

                  <td
                    scope="col"
                    v-if="partnerHeader.country=='India'"
                  >{{statutoryDetails.isMsme == 'N' ? 'No' : statutoryDetails.isMsme == 'Y' ? 'Yes' : '' }}</td>
                  <td
                    scope="col"
                    v-if="partnerHeader.country=='India'"
                  >{{statutoryDetails.msmedNumber}}</td>
                  <td scope="col" v-if="partnerHeader.country=='India'">
                    <a
                      v-if="statutoryDetails.msmeDocId!=null"
                      @click="showAttachFile(statutoryDetails.msmeDocId)"
                      href="#"
                    >{{getFileName(statutoryDetails.msmeDocId)}}</a>
                    <span v-else>{{getFileName(statutoryDetails.msmeDocId)}}</span>
                  </td>
                  <td
                    scope="col"
                    v-if="partnerHeader.country=='India'"
                  >{{statutoryDetails.msmeType}}</td>
                  <td
                    scope="col"
                    v-if="partnerHeader.country=='India'"
                  >{{statutoryDetails.certificateEffectiveFrom}}</td>
                  <td
                    scope="col"
                    v-if="partnerHeader.country=='India'"
                  >{{statutoryDetails.msmeClassificationYear}}</td>
                  <td
                    scope="col"
                    v-if="partnerHeader.country!='India'"
                  >{{statutoryDetails.vatNumber}}</td>
                  <td scope="col" v-if="partnerHeader.country!='India'">
                    <a
                      v-if="statutoryDetails.vatDocumentId!=null"
                      @click="showAttachFile(statutoryDetails.vatDocumentId)"
                      href="#"
                    >{{getFileName(statutoryDetails.vatDocumentId)}}</a>
                    <span v-else>{{getFileName(statutoryDetails.vatDocumentId)}}</span>
                  </td>
                  <td
                    scope="col"
                    v-if="partnerHeader.country=='India'"
                  >{{statutoryDetails.aadhaarNumber}}</td>
                  <td scope="col" v-if="partnerHeader.country=='India'">
                    <a
                      v-if="statutoryDetails.aadhaarDocumentId!=null"
                      @click="showAttachFile(statutoryDetails.aadhaarDocumentId)"
                      href="#"
                    >{{getFileName(statutoryDetails.aadhaarDocumentId)}}</a>
                    <span v-else>{{getFileName(statutoryDetails.aadhaarDocumentId)}}</span>
                  </td>
                </tr>
                <tr v-if="statutoryDetails && statutoryDetails.length == 0">
                  <td colspan="11" class="m-0 p-0">
                    <div class="m-0 p-3 text-center">No Statutory details available</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="font-weight: bold;text-align: left;">Requested Statutory Details</div>
        <div class="pb-3">
          <div class="table-wrapper-scroll-y my-custom-scrollbar table-responsive">
            <table class="table table-striped mb-0">
              <thead>
                <tr>
                  <th scope="col">Document Number</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">TAN Number</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">TAN Dcoument</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">Is MSME</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">MSME Number</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">MSME Document</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">MSME Type</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">MSME Effective From</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">MSME Classification Year</th>
                  <th scope="col" v-if="partnerHeader.country!='India'">VAT Number</th>
                  <th scope="col" v-if="partnerHeader.country!='India'">VAT Document</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">Aadhaar Number</th>
                  <th scope="col" v-if="partnerHeader.country=='India'">Aadhaar Document</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-for="(statutory,index) in statutoryQLDetails" :key="index">
                  <td scope="col">{{statutory.id.documentNumber}}</td>
                  <td scope="col" v-if="partnerHeader.country=='India'">{{statutory.tanNumber}}</td>

                  <td scope="col" v-if="partnerHeader.country=='India'">
                    <a
                      v-if="statutory.tanDocumentId!=null"
                      @click="showAttachFile(statutory.tanDocumentId)"
                      href="#"
                    >{{getFileName(statutory.tanDocumentId)}}</a>
                    <span v-else>{{getFileName(statutory.tanDocumentId)}}</span>
                  </td>
                  <td
                    scope="col"
                    v-if="partnerHeader.country=='India'"
                  >{{statutory.isMsme == 'N' ? 'No' : statutory.isMsme == 'Y' ? 'Yes' : '' }}</td>
                  <td scope="col" v-if="partnerHeader.country=='India'">{{statutory.msmedNumber}}</td>
                  <td scope="col" v-if="partnerHeader.country=='India'">
                    <a
                      v-if="statutory.msmeDocId!=null"
                      @click="showAttachFile(statutory.msmeDocId)"
                      href="#"
                    >{{getFileName(statutory.msmeDocId)}}</a>
                    <span v-else>{{getFileName(statutory.msmeDocId)}}</span>
                  </td>
                  <td scope="col" v-if="partnerHeader.country=='India'">{{statutory.msmeType}}</td>
                  <td
                    scope="col"
                    v-if="partnerHeader.country=='India'"
                  >{{statutory.certificateEffectiveFrom}}</td>
                  <td
                    scope="col"
                    v-if="partnerHeader.country=='India'"
                  >{{statutory.msmeClassificationYear}}</td>
                  <td scope="col" v-if="partnerHeader.country!='India'">{{statutory.vatNumber}}</td>
                  <td scope="col" v-if="partnerHeader.country!='India'">
                    <a
                      v-if="statutory.vatDocumentId!=null"
                      @click="showAttachFile(statutory.vatDocumentId)"
                      href="#"
                    >{{getFileName(statutory.vatDocumentId)}}</a>
                    <span v-else>{{getFileName(statutory.vatDocumentId)}}</span>
                  </td>
                  <td scope="col" v-if="partnerHeader.country=='India'">{{statutory.aadhaarNumber}}</td>
                  <td scope="col" v-if="partnerHeader.country=='India'">
                    <a
                      v-if="statutory.aadhaarDocumentId!=null"
                      @click="showAttachFile(statutory.aadhaarDocumentId)"
                      href="#"
                    >{{getFileName(statutory.aadhaarDocumentId)}}</a>
                    <span v-else>{{getFileName(statutory.aadhaarDocumentId)}}</span>
                  </td>
                </tr>
                <tr v-if="statutoryQLDetails.length == 0">
                  <td colspan="11" class="m-0 p-0">
                    <div class="m-0 p-3 text-center">No Statutory details available</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="moduleWorkflow=='PES'">
        <div style="font-weight: bold;text-align: left;margin-top:10px;">Existing Status Details</div>
        <div class="pb-3">
          <div
            class="table-wrapper-scroll-y my-custom-scrollbar table-responsive"
            style="opacity:0.6;cursor:none;"
          >
            <table class="table table-striped mb-0">
              <thead>
                <tr>
                  <th scope="col">Status</th>
                  <th scope="col">Attachment</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-if="statusDetails">
                  <td scope="col">{{statusDetails.status}}</td>

                  <td scope="col">
                    <a
                      v-if="statusDetails.statusDocumentId!=null"
                      @click="showAttachFile(statusDetails.statusDocumentId)"
                      href="#"
                    >{{getFileName(statusDetails.statusDocumentId)}}</a>
                    <span v-else>{{getFileName(statusDetails.statusDocumentId)}}</span>
                  </td>
                </tr>
                <tr v-if="statusDetails && statusDetails.length == 0">
                  <td colspan="11" class="m-0 p-0">
                    <div class="m-0 p-3 text-center">No Statutory details available</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="font-weight: bold;text-align: left;">Requested Status Details</div>
        <div class="pb-3">
          <div class="table-wrapper-scroll-y my-custom-scrollbar table-responsive">
            <table class="table table-striped mb-0">
              <thead>
                <tr>
                  <th scope="col">Document Number</th>
                  <th scope="col">Status</th>
                  <th scope="col">Status Document</th>
                  <th scope="col">Status remarks</th>
                  <th scope="col">Effective Upto</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-if="statusQLDetails" :key="index">
                  <td scope="col">{{statusQLDetails.documentNumber}}</td>
                  <td scope="col">{{statusQLDetails.status}}</td>

                  <td scope="col">
                    <a
                      v-if="statusQLDetails.statusDocId!=null"
                      @click="showAttachFile(statusQLDetails.statusDocId)"
                      href="#"
                    >{{getFileName(statusQLDetails.statusDocId)}}</a>
                    <span v-else>{{getFileName(statusQLDetails.statusDocId)}}</span>
                  </td>
                  <td scope="col">{{statusQLDetails.remarks}}</td>
                  <td scope="col">{{statusQLDetails.effectiveDateUpto}}</td>
                </tr>
                <tr v-if="statusQLDetails.length == 0">
                  <td colspan="11" class="m-0 p-0">
                    <div class="m-0 p-3 text-center">No Statutory details available</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="moduleWorkflow=='PAB'">
        <div
          class="inner-title mb-3 mt-3"
          style="padding-top:20px; border-top:1px solid #ccc;font-weight:bold;font-size:18px;"
        >Existing Address Details</div>
        <div
          class="table-wrapper-scroll-y my-custom-scrollbar table-responsive"
          style="opacity:0.6;cursor:none;"
        >
          <table class="table table-striped mb-0">
            <thead>
              <tr>
                <th scope="col">Address Type</th>
                <th scope="col">Address line</th>
                <th scope="col">Country</th>
                <th scope="col">State</th>
                <th scope="col">City</th>
                <th scope="col">Zip code</th>
                <th scope="col">Is SEZ</th>
                <th scope="col">Attachment</th>
              </tr>
            </thead>
            <tbody class="text-left table-body">
              <tr v-for="(addr,index) in addressApprovedDetails" :key="index">
                <td scope="col">{{addr.addressType}}</td>
                <td scope="col" style="width:120px">{{addr.streetAddress}}</td>
                <td scope="col">{{addr.country}}</td>
                <td scope="col">{{addr.state}}</td>
                <td scope="col">{{addr.city}}</td>
                <td scope="col">{{addr.sezTag}}</td>
                <td scope="col">{{addr.zipCode}}</td>

                <td scope="col">
                  <a
                    v-if="addr.documentId!=null"
                    @click="showAttachFile(addr.documentId)"
                    href="#"
                  >{{getFileName(addr.documentId)}}</a>
                  <span v-else>-</span>
                </td>
              </tr>
              <tr v-if="addressApprovedDetails.length == 0">
                <td colspan="11" class="m-0 p-0">
                  <div class="m-0 p-3 text-center">No address records available</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          class="inner-title mb-3 mt-3"
          style="padding-top:20px; border-top:1px solid #ccc;font-weight:bold;font-size:18px;"
        >Requested Address Details</div>
        <div class="table-wrapper-scroll-y my-custom-scrollbar table-responsive">
          <table class="table table-striped mb-0">
            <thead>
              <tr>
                <th scope="col">Address Type</th>
                <th scope="col">Address line</th>
                <th scope="col">Country</th>
                <th scope="col">State</th>
                <th scope="col">City</th>
                <th scope="col">Zip code</th>
                <th scope="col">Is SEZ</th>
                <th scope="col">Remarks</th>
                <th scope="col">Attachment</th>
              </tr>
            </thead>
            <tbody class="text-left table-body">
              <tr v-for="(addr,index) in addressQLDetails" :key="index">
                <td scope="col" style="width:120px">{{addr.addressType}}</td>
                <td scope="col" style="width:120px">{{addr.streetAddress}}</td>
                <td scope="col">{{addr.country}}</td>
                <td scope="col">{{addr.state}}</td>
                <td scope="col">{{addr.city}}</td>
                <td scope="col">{{addr.zipCode}}</td>

                <td scope="col">{{addr.sezTag}}</td>
                <td scope="col">{{addr.remarks}}</td>

                <td scope="col">
                  <a
                    v-if="addr.documentId!=null"
                    @click="showAttachFile(addr.documentId)"
                    href="#"
                  >{{getFileName(addr.documentId)}}</a>
                  <span v-else>-</span>
                </td>
              </tr>
              <tr v-if="addressQLDetails.length == 0">
                <td colspan="11" class="m-0 p-0">
                  <div class="m-0 p-3 text-center">No address records available</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="moduleWorkflow=='PTD'">
        <div
          class="inner-title mb-3 mt-3"
          style="padding-top:20px; border-top:1px solid #ccc;font-weight:bold;font-size:18px;"
        >Existing Country Details</div>
        <div class="table-wrapper-scroll-y my-custom-scrollbar table-responsive" style>
          <table class="table table-striped mb-0">
            <thead>
              <tr>
                <th scope="col">Existing Country</th>
                <th scope="col" style="font-weight:bold;">Requested Country</th>
                <th scope="col" style="font-weight:bold;">Remarks</th>
                <th scope="col">Attachment</th>
              </tr>
            </thead>
            <tbody class="text-left table-body">
              <tr>
                <td scope="col">{{countryQLDetails.approvedCountry}}</td>
                <td
                  scope="col"
                  style="font-weight:bold;font-size: 16px;"
                >{{countryQLDetails.requestedCountry}}</td>

                <td scope="col">{{countryQLDetails.remarks}}</td>
                <td scope="col">
                  <a
                    v-if="countryQLDetails.docId!=null"
                    @click="showAttachFile(countryQLDetails.docId)"
                    href="#"
                  >{{getFileName(countryQLDetails.docId)}}</a>
                  <span v-else>-</span>
                </td>
              </tr>
              <tr v-if="countryApprovedDetails.length == 0">
                <td colspan="11" class="m-0 p-0">
                  <div class="m-0 p-3 text-center">No country records available</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div>
      <button
        v-if="moduleWorkflow != 'PCR'"
        class="save-and-continue-approve cursor-pointer"
        @click="documentApprover('1')"
      >APPROVE</button>

      <button
        v-if="moduleWorkflow =='PCR' && forwardToList.length!=0"
        class="save-and-continue-approve cursor-pointer"
        @click="resolvePCR()"
      >MARK IT RESOLVED</button>
      <button
        v-if="moduleWorkflow !='COB' && (moduleWorkflow !='PCR' && 
        ((userName !='buyer' || moduleWorkflow =='PBC') && moduleWorkflow !='feedback'))"
        class="reject-and-continue-approve cursor-pointer"
        @click="rejectReview('3')"
      >REJECT</button>
      <button
        v-if="createdCommunityCode!=1 && (userName !='approver' && userName !='commercial' 
        && moduleWorkflow !='feedback' && moduleWorkflow !='PTM' && moduleWorkflow !='PBC'
         && moduleWorkflow !='PTD' && moduleWorkflow !='PES')"
        class="save-and-continue cursor-pointer"
        @click="sendBack('2')"
      >{{moduleWorkflow =='PCR' && forwardToList.length==0 ? 'SEND REVIEW':'SEND BACK'}}</button>

      <button
        v-if="moduleWorkflow =='PCR' && forwardToList.length!=0"
        class="save-and-continue-approve cursor-pointer"
        @click="documentApprover('1')"
        :class="forwardTo.length>0 && selectedEmployeeList.length>0 ? '' : 'disable-forward'"
      >FORWARD</button>

      <div
        style="float:right;padding: 20px;padding: 3px 20px 0px 20px;text-align: left;"
        v-if="forwardToList.length!=0"
      >
        <div>Forward To Users:</div>
        <multiSelect
          v-if="moduleWorkflow =='PCR'"
          id="multiSelectForwardToUsers"
          class="field-headings pt-1"
          v-model="selectedEmployeeList"
          :position="'top'"
          :options="frOptions"
          :selectOptions="employeeList"
          :btnLabel="selectedEmployees"
          :search="true"
        />
      </div>
      <div
        style="float:right;padding: 20px;padding: 3px 20px 0px 20px;text-align: left;"
        v-if="forwardToList.length!=0"
      >
        <div>Forward To Roles:</div>
        <multiSelect
          v-if="moduleWorkflow =='PCR'"
          id="multiSelectForwardTo"
          class="field-headings pt-1"
          v-model="forwardTo"
          :position="'top'"
          :options="frOptions"
          :selectOptions="forwardToList"
          :btnLabel="selectedFrCode"
          :search="true"
          @close="getEmpList(forwardTo)"
        />
      </div>
    </div>

    <b-modal
      v-model="resolvePCRModel"
      ok-title="Submit"
      title="Overall Confirmation"
      @ok="resolvePCRFinal($event)"
      @cancel="eventCancel($event)"
      :centered="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :ok-only="true"
      body-class="modal-body-class"
      :ok-disabled="enableSubmit"
      :size="moduleWorkflow =='PCR' ? 'xl' : ''"
    >
      <w-text-area
        class="my-4 mx-4"
        :rows="3"
        style="text-align: left;padding-left:1%"
        @inputChanges="getOverallRemarks($event)"
        :title="'Remarks'"
        maxCharacter="500"
        validation="required"
      />

      <!-- attachment -->
      <div v-for="(i,index) in attachments" :key="i" style="padding:0px 40px;">
        <input
          class="form-control"
          type="text"
          style="max-width:200px;display:inline-block;margin-right:20px;"
          v-model="i.nameOfTheAttachment"
          :placeholder="'Name of the attachment..'"
        />

        <div style="display:inline-block;">
          <FileUploader
            style="display: inline-block;"
            :heading="'Attach document'"
            @fileInputChange="UploadDocument($event, index)"
          />

          <ul style="list-style-type:disc;display: inline-block;" v-if="i.attachmentFileId">
            <li
              style="max-width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
            >
              <a
                @click="showAttachFile(i.attachmentFileId)"
                href="#"
                class="mt-n2"
              >{{getFileName(i.attachmentFileId)}}</a>
            </li>
          </ul>
          <span
            @click="removeAttachment(index)"
            style="padding: 25px;cursor:pointer;"
            title="Remove Attachment"
          >
            <img style="height:25px" src="@/assets/delete_Icon.svg" />
          </span>
        </div>
      </div>
      <div style="padding:0px 40px;">
        <button
          @click="addAttachment()"
          class="btn btn-primary"
          style="padding: 0px 10px;margin-top: 5px;"
        >+ Add more attachments</button>
      </div>
    </b-modal>

    <b-modal
      v-model="OverAllSubmitApprover"
      ok-title="Submit"
      title="Overall Confirmation"
      @ok="partnerApproval($event)"
      @cancel="eventCancel($event)"
      :centered="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :ok-only="true"
      body-class="modal-body-class"
      :ok-disabled="enableSubmit"
      :size="moduleWorkflow =='PCR' ? 'xl' : ''"
    >
      <w-text-area
        class="my-4 mx-4"
        :rows="3"
        style="text-align: left;padding-left:1%"
        @inputChanges="getOverallRemarks($event)"
        :title="'Remarks'"
        maxCharacter="500"
        validation="required"
      />

      <diV v-if="moduleWorkflow=='PCR'">
        <!-- attachment -->
        <div v-for="(i,index) in attachments" :key="i" style="padding:0px 40px;">
          <input
            class="form-control"
            type="text"
            style="max-width:200px;display:inline-block;margin-right:20px;"
            v-model="i.nameOfTheAttachment"
            :placeholder="'Name of the attachment..'"
          />

          <div style="display:inline-block;">
            <FileUploader
              style="display: inline-block;"
              :heading="'Attach document'"
              @fileInputChange="UploadDocument($event, index)"
            />

            <ul style="list-style-type:disc;display: inline-block;" v-if="i.attachmentFileId">
              <li
                style="max-width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
              >
                <a
                  @click="showAttachFile(i.attachmentFileId)"
                  href="#"
                  class="mt-n2"
                >{{getFileName(i.attachmentFileId)}}</a>
              </li>
            </ul>
            <span
              @click="removeAttachment(index)"
              style="padding: 25px;cursor:pointer;"
              title="Remove Attachment"
            >
              <img style="height:25px" src="@/assets/delete_Icon.svg" />
            </span>
          </div>
        </div>
        <div style="padding:0px 40px;">
          <button
            @click="addAttachment()"
            class="btn btn-primary"
            style="padding: 0px 10px;margin-top: 5px;"
          >+ Add more attachments</button>
        </div>
      </diV>
    </b-modal>

    <b-modal
      v-if="showContigentPopUp"
      v-model="showContigentPopUp"
      centered
      :hide-header="true"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      id="secondary-business"
      size="lg"
    >
      <p class="secondary-account-modal m-2">
        <span>BUSINESS CATEGORY</span>
        <!-- <span v-if="radioInputValue.length == 1">&nbsp;({{radioInputValue[0].longDesc}})</span> -->
        <img
          @click="closeSecondaryModal()"
          class="pb-1 secondary-close cursor-pointer"
          src="@/assets/images/close1.svg"
        />
      </p>
      <hr class="hr-style mb-3" />
      <v-radio-group
        v-if="radioInputValue.length > 1"
        class="contigent-radio"
        v-model="contigentValue"
        row
      >
        <v-radio
          v-for="(radio,i) in radioInputValue"
          :key="i"
          :class="'contigent-vendor-radio mr-5'"
          :label="radio.longDesc"
          color="#003a78"
          :value="radio.classificationCode"
        ></v-radio>
        <!-- :disabled="radio.classificationCode != 1"
        :defaultValue="1"-->
      </v-radio-group>
      <div v-if="contigentValue == 2" class="m-0 p-0 row">
        <span class="col-6">
          <h5 class="m-0 contact-class">Select Job *</h5>
          <multiSelect
            id="multiSelectBuyer"
            class="field-headings pl-1 py-2"
            v-model="selectedJobValue"
            :position="position"
            :options="options"
            :selectOptions="getJobValue"
            :btnLabel="selectedJob"
            :search="true"
          />
        </span>
        <span class="col-6">
          <h5 class="m-0 contact-class">Select Empanel enddate*</h5>
          <datepicker
            class="w-100 pt-2"
            :id="inputId"
            :value="defaultValue"
            :name="errorMessage"
            :required="isRequired"
            v-validate="'required'"
            :disabledDates="state.disabledDates"
            @selected="getJobdate($event)"
            :calendar-button="true"
            calendar-button-icon="calendar-icon"
            :disabled="selectedJobValue.length == 0"
            v-b-tooltip.hover.top="selectedJobValue.length == 0 ?'Please Select Job':''"
          ></datepicker>
        </span>
      </div>
      <div v-if="contigentValue">
        <h5 class="m-0 mt-1 ml-3 contact-class">Remarks *</h5>
        <w-text-area
          :rows="3"
          class="mx-3 mt-2"
          style="text-align: left;padding-left:1%"
          @inputChanges="getOverallRemarks($event)"
          maxCharacter="500"
          validation="required"
        />
      </div>
      <b-button
        v-if="contigentValue"
        @click="overAllSumbit()"
        class="w-25 float-right mr-4 mt-2 mb-2 cursor-pointer"
        :disabled="checkMandatoryFields()"
      >Submit</b-button>
      <!--   <v-tooltip class="float-right" v-model="madatoryFileds" top>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon color="grey lighten-1">mdi-cart</v-icon>
            </v-btn>
          </template>
          <span>Programmatic tooltip</span>
      </v-tooltip>-->
    </b-modal>

    <w-modal
      :trigger="triggerModal"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModal"
      :showSuccess="successModal"
      @eventClose="closeModal()"
    />
    <w-loading-spinner :loadSpinner="loading" />
  </div>
</template>

<script>
import multiSelect from "vue-multi-select";
import { SummaryServices } from "../services/summaryService";
import quicklinkWorkflow from "../components/summary/quicklinkWorkflow";
import customerWorkflow from "../components/summary/customerWorkflow";
import kycWorkflow from "../components/summary/kycWorkflow";

import testimonialsWorkflow from "../components/summary/testimonialsWorkflow";
import partnerEvaluation from "../components/partnerfeedback/partnerEvaluation";
import gstWorkflow from "../components/summary/gstApproval";
import businessCategoryWorkflow from "../components/summary/businessCategoryApproval";
import SummaryNavbar from "../components/summary/summaryNavbar";
import TextArea from "../widgets/TextArea";
import LoadingSpinner from "../widgets/LoadingSpinner";
import widgetModal from "../widgets/newModalWidget";
import moment from "moment";

import { OnBoardingServices } from "../services/onBoardingService";
import partnerClaimEvaluation from "../components/partnerclaim/partnerClaimEvaluation";
const summaryService = new SummaryServices();
import Datepicker from "vuejs-datepicker";
import { AESService } from "../services/AES.js";
let aesService = new AESService();

import FileUploader from "../widgets/FileUploader.vue";
const OnBoardingService = new OnBoardingServices();
export default {
  components: {
    "c-evaluation": partnerClaimEvaluation,
    "c-gst": gstWorkflow,
    "c-quicklink": quicklinkWorkflow,
    "c-cob": customerWorkflow,
    "c-kyc": kycWorkflow,
    "c-testimonials": testimonialsWorkflow,
    "c-business-category": businessCategoryWorkflow,
    "c-summary-navbar": SummaryNavbar,
    "c-feedback": partnerEvaluation,
    "w-text-area": TextArea,
    "w-loading-spinner": LoadingSpinner,
    "w-modal": widgetModal,
    multiSelect,
    Datepicker,
    FileUploader
  },
  data() {
    return {
      createdCommunityCode: "",
      attachments: [{ nameOfTheAttachment: "", attachmentFileId: "", attachmentSiteUrl: "" }],
      attachmentObj: { nameOfTheAttachment: "", attachmentFileId: "", attachmentSiteUrl: "" },
      forwardTo: [],
      selectedEmployeeList: [],
      employeeMasterList: [],
      employeeList: [],
      isCOB: false,
      isKYC: false,
      showForward: true,
      forwardToList: [],
      resolvePCRModel: false,
      PCRResponse: "",
      claimDetails: [],
      countryQLDetails: [],
      countryApprovedDetails: [],
      addressQLDetails: [],
      addressApprovedDetails: [],
      statusQLDetails: [],
      statusDetails: [],
      statQLDetails: [],
      statApprovedDetails: [],
      partnerHeader: "",
      originalArray: [],
      frRolesList: [],
      traceData: [],
      tableValue: [],
      answerNumber: "",
      userId: "",
      userCode: "",
      eipUserName: "",
      auditNo: "",
      companyCode: "",
      orderTypeCode: "",
      OverAllSubmitApprover: false,
      openTrackingModal: false,
      partnerLoadig: false,
      overAllremarks: "",
      enableSubmit: true,
      actionStatus: "",
      triggerModal: false,
      successModal: false,
      alertModal: false,
      lastResponse: "",
      gstWorkflow: false,
      quicklinkWorkflow: false,
      customerWorkflow: false,
      kycWorkflow: false,
      testimonialsWorkflow: false,
      feedbackWorkFlow: false,
      moduleWorkflow: "",
      trackingDetails: "",
      roleName: [],
      effectiveFromDate: "",
      effectiveToDate: "",
      businessCatWorkflow: false,
      pcrworkflow: false,
      addrworkflow: false,
      showContigentPopUp: false,
      radioInputValue: [],
      contigentValue: "",
      selectedJobValue: [],
      position: "bottom",
      options: {
        multi: false,
        groups: false,
        loading: true,
        labelList: "elements",
        groupName: "title",
        cssSelected: option =>
          option.selected ? { "background-color": "#ffffff" } : ""
      },
      frOptions: {
        multi: true,
        groups: false,
        loading: true,
        labelList: "elements",
        groupName: "title",
        cssSelected: option =>
          option.selected ? { "background-color": "#ffffff" } : ""
      },
      getJobValue: [],
      selectedJob: values => `Selected Job (${values.length})`,
      selectedFrCode: values => `Selected Roles (${values.length})`,
      selectedEmployees: values => `Selected Employees (${values.length})`,
      state: {
        disabledDates: {
          from: "",
          to: ""
        }
      },
      contigentEndDate: "",
      overallRemarkspopUp: "",
      madatoryFileds: false
    };
  },
  created() {
    this.decryptfunction();
    var self = this;
    EventBus.$on("responseByLnt", function(val) {
      self.PCRResponse = val;
    });
  },
  computed: {},
  methods: {
    addAttachment() {
      if (this.attachments.length < 10) {
        this.attachments.push({
          nameOfTheAttachment: "",
          attachmentFileId: "",
          attachmentSiteUrl: ""
        });
      } else {
        window.alert("You have reached the maximum limit of attachments!");
      }
    },
    removeAttachment(i) {
      if (this.attachments.length > 1) {
        this.attachments.splice(i, 1);
      } else {
        this.attachments = [{ nameOfTheAttachment: "", attachmentFileId: "", attachmentSiteUrl: "" }];
      }
    },
    UploadDocument(event, index) {
      let data = new FormData();
      let file = event[0];
      // data.append("name", "my-file");
      data.append("file", file);
      this.loading = true;

      OnBoardingService.uploadAttachments(data)
        .then(resp => {
          if (resp) {
            this.loading = false;
            this.attachments[index].attachmentFileId = resp.UniqueID;
            this.attachments[index].attachmentSiteUrl = resp.SiteUrl;
          } else {
            this.triggerModal = true;
            this.loading = false;
            this.triggerModal = true;
            this.lastResponse = "Something went wrong. Try After Sometime";
            this.alertsuccess = true;
          }
        })
        .catch(error => {
          this.triggerModal = true;
          this.loading = false;
          this.triggerModal = true;
          this.lastResponse = " Try After Sometime";
          this.alertsuccess = true;
        });
    },
    showAttachFile(event) {
      this.loading = true;
      OnBoardingService.downLoadDocument(event)
        .then(res => {
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    getFileName(fileName) {
      if (fileName == null) return "--";
      var fileNameFinal = "";
      fileNameFinal = fileName.split(/_(.+)/)[1];
      return fileNameFinal;
    },
    goToVendorMasterPage() {
      var pn = this.partnerHeader.partnerNumber;
      var p = this.partnerHeader.partnerTypeList[0].id.partnerId;
      const routeData = this.$router.resolve({
        name: "VendorDetails",
        query: { pid: p, pno: pn }
      });
      window.open(routeData.href, "_blank");
      // this.$router.push("/partnerforensics");
    },
    decryptfunction() {
      var CryptoJS = require("crypto-js");
      var token = sessionStorage.getItem("summaryToken");
      var bytes = CryptoJS.AES.decrypt(
        token.toString(),
        atob(process.env.VUE_APP_S_S)
      );
      var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      this.answerNumber = decryptedData.decodedRequestNumber;
      this.protalName = decryptedData.evaluatorsRole;
      this.userId = decryptedData.eipUsersUserid;
      this.userCode = decryptedData.evaluatorsFRCode;
      this.eipUserName = decryptedData.eipUserName;
      this.auditNo = decryptedData.auditNumber;
      if (this.answerNumber) {
        summaryService
          .getPartnerHeader("", "", this.answerNumber)
          .then(resp => {
            if (resp) {
              this.partnerHeader = resp.response;
            }
          });
        var checkAnswerNumber = this.answerNumber.substring(0, 3);
        if (checkAnswerNumber == "PCR") {
          this.getForwardToList();
        }
        var FeedBackAnswerNumber = this.answerNumber.includes("PFB");
        if (FeedBackAnswerNumber) {
          this.moduleWorkflow = "feedback";
          this.feedbackWorkFlow = true;
          return;
        } else {
          if (
            checkAnswerNumber == "PQL" ||
            checkAnswerNumber == "PBD" ||
            checkAnswerNumber == "PFP"
          ) {
            this.moduleWorkflow = "quicklink";
            this.quicklinkWorkflow = true;
            this.openTrackingStatus();
          } else if (checkAnswerNumber == "GST") {
            this.moduleWorkflow = "gst";
            this.gstWorkflow = true;
            this.openTrackingStatus();
          } else if (checkAnswerNumber == "PTM") {
            this.moduleWorkflow = "PTM";
            this.testimonialsWorkflow = true;
          } else if (checkAnswerNumber == "PBC") {
            this.moduleWorkflow = "PBC";
            this.businessCatWorkflow = true;
          } else if (checkAnswerNumber == "COB") {
            this.moduleWorkflow = "COB";
            this.customerWorkflow = true;
            this.isCOB = true;
          } else if (checkAnswerNumber == "PCR") {
            this.moduleWorkflow = "PCR";
            this.pcrworkflow = true;
            this.getClaimDetails();
          } else if (checkAnswerNumber == "PAB") {
            this.moduleWorkflow = "PAB";
            this.addrworkflow = true;
            this.getAddressDetails();
          } else if (checkAnswerNumber == "PSD") {
            this.moduleWorkflow = "PSD";
            this.statworkflow = true;
            this.getStatDetails();
          } else if (checkAnswerNumber == "PTD") {
            this.moduleWorkflow = "PTD";
            this.PTDworkflow = true;
            this.getPTDDetails();
          } else if (checkAnswerNumber == "KYC") {
            this.moduleWorkflow = "KYC";
            this.kycWorkflow = true;
            this.isKYC = true;
          } else if (checkAnswerNumber == "PES") {
            this.moduleWorkflow = "PES";
            this.statusworkflow = true;
            this.getStatusDetails();
          }
        }
      }
      this.getAllInfo();
    },
    getPTDDetails() {
      summaryService
        .fetchCountryQLDetails(this.auditNo, this.answerNumber)
        .then(resp => {
          if (resp.response) {
            console.log(resp.response);
            this.countryQLDetails = resp.response;
          }
        })
        .catch(err => {
          this.loading = false;
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = err.failureMessage
            ? err.failureMessage
            : "Something went wrong. Try again later.";
          this.alertModal = true;
        });
    },
    getAddressDetails() {
      summaryService
        .fetchAddressQLDetails(this.auditNo, this.answerNumber)
        .then(resp => {
          if (resp.response) {
            console.log(resp.response);
            this.addressQLDetails = resp.response;
          }
        })
        .catch(err => {
          this.loading = false;
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = err.failureMessage
            ? err.failureMessage
            : "Something went wrong. Try again later.";
          this.alertModal = true;
        });

      summaryService
        .fetchAddressApprovedDetails(this.auditNo, this.answerNumber)
        .then(resp => {
          if (resp.response) {
            console.log(resp.response);
            this.addressApprovedDetails = resp.response;
          }
        })
        .catch(err => {
          this.loading = false;
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = err.failureMessage
            ? err.failureMessage
            : "Something went wrong. Try again later.";
          this.alertModal = true;
        });
    },

    getStatDetails() {
      summaryService
        .fetchStatQLDetails(this.auditNo, this.answerNumber)
        .then(resp => {
          if (resp.response.list) {
            console.log(resp.response);
            this.statutoryQLDetails = resp.response.list;

            this.createdCommunityCode = resp.response.communityCode;
          }
        })
        .catch(err => {
          this.loading = false;
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = err.failureMessage
            ? err.failureMessage
            : "Something went wrong. Try again later.";
          this.alertModal = true;
        });

      summaryService
        .fetchStatApprovedDetails(this.auditNo, this.answerNumber)
        .then(resp => {
          if (resp.response) {
            console.log(resp.response);
            this.statutoryDetails = resp.response;
          }
        })
        .catch(err => {
          this.loading = false;
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = err.failureMessage
            ? err.failureMessage
            : "Something went wrong. Try again later.";
          this.alertModal = true;
        });
    },
    getStatusDetails() {
      summaryService
        .fetchStatusQLDetails(this.auditNo, this.answerNumber)
        .then(resp => {
          if (resp.response) {
            console.log(resp.response);
            this.statusQLDetails = resp.response;
          }
        })
        .catch(err => {
          this.loading = false;
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = err.failureMessage
            ? err.failureMessage
            : "Something went wrong. Try again later.";
          this.alertModal = true;
        });

      summaryService
        .fetchStatusApprovedDetails(this.auditNo, this.answerNumber)
        .then(resp => {
          if (resp.response) {
            console.log(resp.response);
            this.statusDetails = resp.response;
          }
        })
        .catch(err => {
          this.loading = false;
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = err.failureMessage
            ? err.failureMessage
            : "Something went wrong. Try again later.";
          this.alertModal = true;
        });
    },
    getClaimDetails() {
      summaryService
        .fetchClaimDetails(this.auditNo, this.answerNumber)
        .then(resp => {
          if (resp.response) {
            console.log(resp.response);
            this.claimDetails = resp.response;
          }
        })
        .catch(err => {
          this.loading = false;
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = err.failureMessage
            ? err.failureMessage
            : "Something went wrong. Try again later.";
          this.alertModal = true;
        });
    },
    getRoleName(frCode) {
      if (frCode == 0) {
        return "Partner";
      }
      return this.frRolesList.filter(x => x.frCode == frCode).length > 0
        ? this.frRolesList.filter(x => x.frCode == frCode)[0].longDesc
        : "Not available";
    },
    formatDateTime(dt, splitter) {
      var dateArray = dt.split(splitter)[0].split("-");
      var timeArray = dt.split(splitter)[1].split(":");
      var date = dateArray[2];
      var month = dateArray[1];
      var year = dateArray[0];
      var h = timeArray[0];
      var m = timeArray[1];
      return (
        date +
        "-" +
        month +
        "-" +
        year +
        " " +
        (h >= 12 ? h - 12 : h) +
        ":" +
        m +
        " " +
        (h >= 12 ? "PM" : "AM")
      );
    },
    gettrackingStatus() {
      summaryService.trackingStatusDetails(this.answerNumber).then(resp => {
        if (resp.response) {
          console.log(resp.response);
          this.trackingDetails = resp.response;
          this.roleName = resp.response.evaluatorsName;
        }
      });
    },
    openTrackingStatus(answerNumber) {
      answerNumber = this.answerNumber;
      //this.currentDocuNumberForAction = answerNumber
      this.loading = true;
      summaryService
        .getWorkFlowHistory(answerNumber)
        .then(res => {
          this.loading = false;
          if (res.status == "SUCCESS") {
            this.originalArray = res.response.workflows;
            this.frRolesList = res.response.frRolesList;
            this.traceData = [];
            var n = [];
            //n.push(this.originalArray[0])
            for (var i = 0; i < this.originalArray.length; i++) {
              if (this.originalArray[i].actionStatus == 6) {
                continue;
              }
              if (this.originalArray.length - 1 == i) {
                n.push(this.originalArray[i]);
                this.traceData.push(n);
                n = [];
              } else if (this.originalArray[i].actionStatus != 2) {
                n.push(this.originalArray[i]);
              } else if (this.originalArray[i].actionStatus == 2) {
                n.push(this.originalArray[i]);
                this.traceData.push(n);
                n = [];
              }
            }
            var lastArray = this.traceData[this.traceData.length - 1];
            var allfour = lastArray.filter(x => x.actionStatus == 4);
            if (allfour.length == lastArray.length) {
              for (var j = 0; j < lastArray.length; j++) {
                lastArray[j]["isShow"] = true;
              }
            }
            this.traceData[this.traceData.length - 1] = lastArray;
            //this.traceData[0][0]["frCode"] = 0
            console.log(this.traceData);
          } else {
            this.triggerModal = true;
            this.loading = false;
            this.failureModal = false;
            this.lastResponse = res.failureMessage;
            this.alertModal = true;
          }
          this.openTrackingModal = true;
        })
        .catch(err => {
          this.loading = false;
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = err.failureMessage
            ? err.failureMessage
            : "Something went wrong. Try again later.";
          this.alertModal = true;
        });
      /*SummaryService.getTrackingData(answerNumber)
        .then(res => {
          this.loading = false;
          this.trackingData = res.response.status;
          this.roleName = res.response.evaluatorsName;
      this.openTrackingModal = true;
        })
        .catch(err => {
          this.loading = false;
        });*/
    },
    getTrackingDetails() {
      this.loading = true;
      if (this.feedbackWorkFlow) {
        summaryService
          .trackingDetailsOfFeedback(this.answerNumber)
          .then(resp => {
            if (resp.response) {
              this.loading = false;
              this.openTrackingModal = true;
              this.trackingDetails = resp.response;
              this.roleName = resp.response.evaluatorsName;
            } else {
              this.loading = false;
            }
          });
      }
      if (this.gstWorkflow || this.quicklinkWorkflow) {
        summaryService
          .getQuicklinkTrackingData(this.answerNumber)
          .then(resp => {
            if (resp.response) {
              this.loading = false;
              this.openTrackingModal = true;
              this.trackingDetails = resp.response.status[0];
              this.roleName = resp.response.evaluatorsName;
            } else {
              this.loading = false;
            }
          });
      }
    },
    //openTrackingStatus() {
    //  this.getTrackingDetails();
    //},
    closeTrackingModal() {
      this.openTrackingModal = false;
    },
    getCreatedDate(date) {
      return moment(date).format("DD-MMM-YYYY hh:mm A");
    },
    getEmpList(frlist) {
      console.log(frlist);

      var self = this;
      this.loading = true;
      this.employeeList = [];
      var data = {
        documentNumber: self.answerNumber,
        erpFrCodeList: self.forwardTo.map(x => x.value),
        userId: this.userId
      };
      summaryService
        .getEmpList(data)
        .then(res => {
          this.loading = false;
          if (res.status == "SUCCESS") {
            //this.forwardToList = res.response
            this.employeeList = [];
            this.employeeMasterList = res.response;
            for (let i = 0; i < res.response.length; i++) {
              this.employeeList.push({
                name:
                  res.response[i].eipUserName +
                  " - " +
                  res.response[i].eipUserEmailId,
                value: res.response[i].eipActualUserId
              });
            }
            //sessionStorage.clear();
          } else {
            window.alert(res.failureMessage);
            self.showForward = false;
          }
        })
        .catch(error => {
          window.alert("Error in getting employee list");
          this.loading = false;
        });
    },
    getAllInfo() {
      this.loading = false;
      if (this.moduleWorkflow == "feedback" || this.moduleWorkflow == "PTM") {
        if (this.userCode == 103) {
          this.loading = false;
          this.userName = "buyer";
          this.protalName = "Buyer";
        } else if (this.userCode == 104) {
          this.loading = false;
          this.userName = "technical";
          this.protalName = "Technical";
        } else if (this.userCode == 105) {
          this.loading = false;
          this.userName = "commercial";
          this.protalName = "Commercial";
        } else if (this.userCode == 106) {
          this.loading = false;
          this.userName = "approver";
          this.protalName = "Approver";
        } else if (this.userCode == 107) {
          this.loading = false;
          this.userName = "projecthead";
          this.protalName = "Project Head";
        } else if (this.userCode == 108) {
          this.loading = false;
          this.userName = "icscmhead";
          this.protalName = "ICSCM Head";
        } else if (this.userCode == 109) {
          this.loading = false;
          this.userName = "buhead";
          this.protalName = "BU Head";
        }
      }
    },
    resolvePCR() {
      this.actionStatus = 1;
      this.overAllremarks = "";
      this.enableSubmit = true;
      this.resolvePCRModel = true;
    },
    resolvePCRFinal() {
      var isPCR = false;
      this.loading = true;
      var formdata = {
        actionStatus: this.actionStatus,
        auditNumber: this.auditNo,
        remarks: this.overAllremarks,
        requestNumber: this.answerNumber,
        classificationCode: 1,
        userId: this.userId,
        attachmentJson: JSON.stringify(this.attachments)
      };
      if (this.moduleWorkflow == "PCR") {
        formdata.reasonTypeCode = this.claimDetails.reasonTypeCode;
        isPCR = true;
      }
      summaryService
        .resolvePCR(formdata)
        .then(resp => {
          if (resp.status == "SUCCESS") {
            this.loading = false;
            this.triggerModal = true;
            this.successModal = true;
            this.lastResponse = resp.response;
            //sessionStorage.clear();
          } else {
            this.loading = false;
            this.triggerModal = true;
            this.lastResponse = resp.failureMessage;
            this.alertModal = true;
          }
        })
        .catch(error => {
          this.loading = false;
          this.triggerModal = true;
          this.lastResponse = error.failureMessage;
          this.alertModal = true;
        });
    },
    getForwardToList() {
      var self = this;
      this.loading = true;
      this.forwardToList = [];
      summaryService
        .getForwardToList(self.answerNumber)
        .then(res => {
          this.loading = false;
          if (res.status == "SUCCESS") {
            //this.forwardToList = res.response
            this.forwardToList = [];
            for (let i = 0; i < res.response.length; i++) {
              this.forwardToList.push({
                name: res.response[i].longDesc,
                value: res.response[i].erpFRCode
              });
            }
            //sessionStorage.clear();
          } else {
            self.showForward = false;
          }
        })
        .catch(error => {
          window.alert("Error in getting forward list");
          this.loading = false;
        });
    },
    documentApprover(value) {
      this.actionStatus = value;
      if (this.moduleWorkflow == "PTM") {
        if (this.effectiveToDate == "" || this.effectiveFromDate == "") {
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = "Please fill the Testimonial duration";
        } else {
          this.actionStatus = value;
          this.overAllremarks = "";
          this.enableSubmit = true;
          this.OverAllSubmitApprover = true;
        }
      } else if (this.moduleWorkflow == "PBC") {
        /*if (this.userName == "buyer") {
          this.actionStatus = value;
          this.getContigentRadioValue();
          this.getContigentJob();
        } else {*/
        this.overallRemarkspopUp = "";
        this.enableSubmit = true;
        this.OverAllSubmitApprover = true;
        //}
      } /*else if (this.moduleWorkflow == "PCR") {
        if(this.PCRResponse.split('~!~').length==2 && 
        this.PCRResponse.split('~!~')[0].trim() != ''){
          this.overallRemarkspopUp = "";
          this.enableSubmit = true;
          this.OverAllSubmitApprover = true;
        } else{
              window.alert("Response/ Remarks by L&T is mandatory!")
        }
      } */ else {
        this.actionStatus = value;
        this.overAllremarks = "";
        this.enableSubmit = true;
        this.OverAllSubmitApprover = true;
      }
    },
    sendBack(value) {
      this.actionStatus = value;
      this.overAllremarks = "";
      this.enableSubmit = true;
      this.OverAllSubmitApprover = true;
    },
    rejectReview(value) {
      this.actionStatus = value;
      this.overAllremarks = "";
      this.enableSubmit = true;
      this.OverAllSubmitApprover = true;
    },
    getOverallRemarks(event) {
      if (event.length > 2) {
        this.enableSubmit = false;
      } else {
        this.enableSubmit = true;
      }
      this.overAllremarks = event;
      if (this.moduleWorkflow == "PBC") {
        this.overallRemarkspopUp = event;
      }
    },
    getUserInputValue(event) {
      this.companyCode = event.companyCode;
      this.orderTypeCode = event.orderType;
    },
    overAllSumbit() {
      if (this.moduleWorkflow == "PTM") {
        var testimonialsApproveData = {
          actionStatus: this.actionStatus,
          effectiveFromDate: this.effectiveFromDate,
          effectiveToDate: this.effectiveToDate,
          requestNumber: this.answerNumber,
          userId: this.userId
        };
        this.loading = true;
        summaryService
          .testimonialsApproval(testimonialsApproveData)
          .then(res => {
            if (res.status == "SUCCESS") {
              this.triggerModal = true;
              this.loading = false;
              this.successModal = true;
              this.lastResponse = "Document Approved Sucessfully";
              //sessionStorage.clear();
            } else {
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = res.failureMessage;
              this.alertModal = true;
            }
          })
          .catch(error => {
            this.triggerModal = true;
            this.loading = false;
            this.lastResponse = error.failureMessage;
            this.alertModal = true;
          });
      } else {
        if (this.moduleWorkflow == "feedback") {
          var formdata = {
            actionStatus: this.actionStatus,
            auditNumber: this.auditNo,
            remarks: this.overAllremarks,
            documentNumber: this.answerNumber,
            companyCode: this.companyCode,
            orderTypeCode: this.orderTypeCode,
            userId: this.userId
          };
        } else {
          var formdata = {
            actionStatus: this.actionStatus,
            auditNumber: this.auditNo,
            remarks: this.overAllremarks,
            requestNumber: this.answerNumber,
            segregatorToBuyers: [],
            userId: this.userId
          };
        }

        this.loading = true;
        summaryService
          .summaryAction(formdata, this.moduleWorkflow, this.userName)
          .then(resp => {
            if (resp.status == "SUCCESS") {
              this.triggerModal = true;
              this.loading = false;
              this.successModal = true;
              this.lastResponse = resp.response;
              //sessionStorage.clear();
            } else {
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = resp.failureMessage;
              this.alertModal = true;
            }
          })
          .catch(error => {
            this.triggerModal = true;
            this.loading = false;
            this.lastResponse = error.failureMessage;
            this.alertModal = true;
          });
      }
    },
    partnerApproval() {
      var isPCR = false;
      if (this.moduleWorkflow == "feedback" || this.moduleWorkflow == "PTM") {
        this.overAllSumbit();
      } else {
        this.loading = true;
        var formdata = {
          actionStatus: this.actionStatus,
          auditNumber: this.auditNo,
          remarks: this.overAllremarks,
          requestNumber: this.answerNumber,
          classificationCode: 1,
          userId: this.userId
        };
        formdata.eipNextUserDetails = [];
        if (this.moduleWorkflow == "PCR") {
          formdata.reasonTypeCode = this.claimDetails.reasonTypeCode;
          formdata.attachmentJson = JSON.stringify(this.attachments);
          isPCR = true;
          for (var i = 0; i < this.selectedEmployeeList.length; i++) {
            formdata.eipNextUserDetails.push(
              this.employeeMasterList.filter(
                x => x.eipActualUserId == this.selectedEmployeeList[i].value
              )[0]
            );
          }
        }
        summaryService
          .overallApprove(
            formdata,
            this.actionStatus,
            isPCR,
            this.isCOB,
            this.isKYC
          )
          .then(resp => {
            if (resp.status == "SUCCESS") {
              this.loading = false;
              this.triggerModal = true;
              this.successModal = true;
              this.lastResponse = resp.response;
              //sessionStorage.clear();
            } else {
              this.loading = false;
              this.triggerModal = true;
              this.lastResponse = resp.failureMessage;
              this.alertModal = true;
            }
          })
          .catch(error => {
            this.loading = false;
            this.triggerModal = true;
            this.lastResponse = error.failureMessage;
            this.alertModal = true;
          });
      }
    },
    changeModalSuccess() {
      //sessionStorage.removeItem("token");
      //location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);

      this.$router.push("/Workbench");
    },
    closeModal() {
      if (this.lastResponse == "Please fill the Testimonial duration") {
        this.triggerModal = false;
        this.alertModal = false;
        this.lastResponse = "";
      } else {
        //sessionStorage.removeItem("token");
        //location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);

        this.$router.push("/Workbench");
      }
    },
    logout() {
      let data = {};
      var logouttime = new Date();
      data.lastActionTime = null;
      data.loginAuditNumber = aesService.EncodeUsingAES(this.auditNo);
      data.logoutTime = logouttime;
      data.logoutType = "U";
      summaryService
        .userLogout(data)
        .then(res => {
          sessionStorage.clear();
          location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
        })
        .catch(err => {
          location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
        });
    },
    getTestimonialDuration(event) {
      console.log(event);
      this.effectiveFromDate = event.effectiveFrom;
      this.effectiveToDate = event.effectiveUpto;
      console.log(this.effectiveFromDate);
      console.log(this.effectiveToDate);
    },
    closeSecondaryModal() {
      this.showContigentPopUp = false;
    },
    getJobdate(event) {
      this.contigentEndDate = event;
    },
    checkMandatoryFields() {
      if (this.contigentValue == 1) {
        if (this.overallRemarkspopUp == "") {
          this.madatoryFileds = true;
          return true;
        } else {
          this.madatoryFileds = false;
          return false;
        }
      }
      if (this.contigentValue == 2) {
        if (
          this.selectedJobValue.length == 0 ||
          this.contigentEndDate == "" ||
          this.overallRemarkspopUp == ""
        ) {
          this.madatoryFileds = true;
          return true;
        } else {
          this.madatoryFileds = false;
          return false;
        }
      }
    },
    getContigentRadioValue() {
      this.loading = true;
      summaryService
        .getContigentRadioInputValue(this.answerNumber)
        .then(resp => {
          if (resp.response) {
            console.log(resp);
            this.loading = false;
            this.showContigentPopUp = true;
            this.radioInputValue = resp.response;
            if (this.radioInputValue.length == 1) {
              this.contigentValue = this.radioInputValue[0].classificationCode;
            }
            // this.contigentValue = 2;
          } else {
            this.loading = false;
            this.triggerModal = true;
            this.lastResponse = resp.failureMessage;
            this.alertModal = true;
          }
          // this.radioInputValue.push({});
        });
    },
    getContigentJob() {
      summaryService
        .getContigentJobValue(this.answerNumber, this.userId)
        .then(resp => {
          resp.response.forEach((buyer, index) => {
            this.getJobValue.push({
              name: buyer.jobDesc,
              value: buyer.jobCode,
              date: buyer.endDate,
              orgin: buyer.orginType
            });
          });
          // this.radioInputValue.push({});
        });
    }
  }
};
</script>

<style scoped>
.save-and-continue-approve {
  width: fit-content;
  padding: 5px;
  border: solid 1px white;
  background-color: #0a9930;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 0.64px;
  padding-right: 40px !important;
  padding-left: 40px !important;
  text-align: left;
  color: #ffffff;
  padding: 10px;
  float: right;
  margin-right: 5%;
  margin-top: 1%;
  margin-bottom: 5%;
}
.reject-and-continue-approve {
  width: fit-content;
  padding: 5px;
  border: solid 1px white;
  background-color: #e33232;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.64px;
  padding-right: 40px !important;
  padding-left: 40px !important;
  text-align: left;
  color: #ffffff;
  padding: 10px;
  float: right;
  margin-right: 5%;
  margin-top: 1%;
  margin-bottom: 5%;
}
.save-and-continue {
  width: fit-content;
  padding: 10px;
  border: solid 1px #002d72;
  background-color: #ffffff;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.64px;
  text-align: left;
  color: #002d72;
  float: right;
  margin-right: 5%;
  margin-top: 1%;
  margin-bottom: 5%;
  padding-right: 40px !important;
  padding-left: 40px !important;
}

/* OTP page modal */

/* Contigent popup */
.secondary-account-modal {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 22px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.05;
  letter-spacing: normal;
  text-align: left;
  color: #636567;
}
.secondary-close {
  position: absolute;
  right: 20px;
  top: 22px;
}
.hr-style {
  background-color: #f8f8f8;
  width: 100%;
  margin: 0 auto;
}
.contigent-radio {
  margin-left: 25% !important;
}
.contigent-vendor-radio {
  border: none;
  border-radius: 50px;
  padding: 8px;
  background-color: #dbe4f2;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #003a78 !important;
  /* color: #4d4c4c;  --  INACTIVE */
}
.contact-class {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
}
</style>
<style >
.model-content {
  width: 100% !important;
}
.modal-header {
  font-family: "Source Sans Pro", sans-serif;
  padding: 2% !important;
  color: white;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.modal-footer > .btn-primary {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  text-align: center;
  color: white !important;
  /* border-radius: 2px; */
  background-color: #1579ab;
}
.summaryNavbar {
  background-color: #14436a;
}
.approverButton {
  font-size: 16px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  outline: none !important;
  padding: 3%;
  float: left;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.approverstatus {
  font-size: 16px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  outline: none !important;
  padding: 3%;
  float: left;
  margin-left: 40%;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.role-Name {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
  font-weight: bold;
  text-decoration: underline;
  margin-bottom: 10% !important;
}
.dottedPending {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #f4cf08;
  float: left;
  margin-top: 2%;
}
.dottedGreen {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #28b915;
  float: left;
  margin-top: 3%;
}
.popOverRemarks {
  cursor: pointer;
  float: left;
  font-size: 12px;
  color: #747474;
  text-decoration: underline;
  outline: none !important;
}
.popOverDate {
  float: left;
  font-size: 12px;
  color: #747474;
}
.disable-forward {
  color: #fff;
  background: #ccc;
  opacity: 0.5;
  pointer-events: none;
}
</style>
